<template>
    <button
        v-if="!isPrintMode"
        :class="[
            'relative font-oceanside min-h-[40px] text-[16px] font-semibold group rounded-full w-full',
            'base-button-flat-animation-arrow text-white overflow-hidden overlap-on-hover-anim-bottom bg-red hover:bg-red-B51029',
            'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
            {
                'opacity-50 hover:opacity-50': isDisabled,
            },
        ]"
    >
        <div
            :class="[
                'absolute top-0 -left-[105%] w-full h-full transition-all ease-linear group-hover:-left-[12px] overlap-on-hover-anim-top bg-red-C62132',
                variant === 'narrow' ? 'overlap-on-hover-anim-top-narrow-path' : 'overlap-on-hover-anim-top-wide-path',
            ]">
        </div>
        <div class="absolute flex w-full justify-center items-center top-0 h-[40px] duration-300">
            <slot />
        </div>
    </button>
</template>

<script>
    import allStores from '../../stores/all';

    export default {
        mixins: [allStores],

        props: {
            isDisabled: {
                type: Boolean,
                default: false,
            },
            variant: {
                type: String,
                default: 'narrow',
            },
        },

        computed: {
            isPrintMode() {
                return this.appStore.isPrintMode;
            },
        },
    };
</script>

<style lang="scss">
#cz3 {
    .base-button-flat-animation-arrow {
        /* background: #e31837 url(../../assets/images/icons/arrow-right-white.svg) no-repeat right 20px center; */
    }

    .overlap-on-hover-anim-top {
        transform: translateX(0);
        transition-duration: 300ms;
    }

    .overlap-on-hover-anim-top-narrow-path {
        clip-path: polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%);
    }

    .overlap-on-hover-anim-top-wide-path {
        clip-path: polygon(0 0, 95% 0, 100% 50%, 95% 100%, 0 100%);
    }
}
</style>